import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonFunctionService {
  user_id:number = 0;
  userName:string = '';
  role:string='';
  public pageTitle:string = '';
  constructor() { }

  restrictCharacters(str:string){
    const invalidChars = ["<", ">", "~", "\\", "-", "+", "e"];

    return invalidChars.includes(str);
  }
}
